(function () {
  var seen = new WeakSet();
  function enhance() {
    document.querySelectorAll('main a[href]').forEach(function (link) {
      if (seen.has(link) || link.closest('nav, header, .fp-article-cta')) return;
      var url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return;
      var label = link.textContent.trim();
      if (!label || link.querySelector('img, svg') || !/申し込|申込|予約|体験|カウンセリング|購入|注文/.test(label)) return;
      seen.add(link);
      var box = document.createElement('span');
      box.className = 'fp-article-cta';
      var note = document.createElement('span');
      note.className = 'fp-article-cta__message';
      note.textContent = /体験|カウンセリング/.test(label)
        ? '体験・カウンセリングから、はじめの一歩を'
        : /予約/.test(label) ? '気になるプラン・空き状況を公式サイトでチェック'
        : /購入|注文/.test(label) ? '最新の価格・特典を販売サイトでチェック'
        : 'プラン・最新の特典を公式サイトでチェック';
      link.parentNode.insertBefore(box, link);
      box.appendChild(note);
      box.appendChild(link);
      link.classList.add('fp-article-cta__button');
    });
  }
  function start() {
    enhance();
    var main = document.querySelector('main');
    if (!main) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; enhance(); });
    }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
